// extracted by mini-css-extract-plugin
export default {"nextButton":"NextButton_nextButton__AAYlv","buttonContainer":"NextButton_buttonContainer__dEysf"};